__turbopack_context__.v({
  "contactButton": "ContactButton-module-scss-module__H5gHeq__contactButton",
});
